const InputField = ({ name, filterValue, valueMinimum, onSelect, required }) => {
    return (
        <div>
          {name && (<label className="black-text" htmlFor={name} style={{ fontWeight: "bold"}}> {name}
            {required && <span className="red-text" style={{ marginLeft: "5px", fontWeight: "bold", verticalAlign: "middle"}}>*</span>}
          </label>)}
          <input
            id={name}
            type="number"
            value={filterValue}
            onChange={e => onSelect(e.target.value)}
            className={`validate ${filterValue === "" || 
              filterValue >= valueMinimum ? "" : "invalid"}`}
          />
          {filterValue !== "" && filterValue < valueMinimum && (
            <span className="helper-text red-text">
              {name} cannot be lower than {valueMinimum}
            </span>
          )}
        </div>
    );
};

export default InputField;